// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607222021/js/" + chunkId + "." + {"44":"54f330d0","225":"8bf2f349","481":"97cbb347","486":"01f4b572","770":"9bd0d97b"}[chunkId] + ".0.9480342904742014.chunk.js";
};